import React from "react";

function Projects() {
  return (
    <div id="projects">
      <h1>Projects</h1>
      <div className="projects-container">
        {/* Stoncs */}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/stoncs"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>Stoncs</h3>
              <p>
                Built an <strong>ML-powered portfolio optimizer</strong> and{" "}
                <strong>trend detector</strong> analyzing how media hype affects
                stock performance. Applied{" "}
                <strong>sentiment analysis and topic modeling</strong> on S&P
                500 news using VADER and TF-IDF.
              </p>
            </div>
          </a>
        </div>

        {/* SwipeShield */}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/swipe-shield"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>SwipeShield</h3>
              <p>
                Built a passive biometric authentication tool. Implemented{" "}
                <strong>K-Means clustering</strong> for anomaly detection.
                Visualized data with Android Debug Bridge and Streamlit.
              </p>
            </div>
          </a>
        </div>

        {/* System Monitoring Tools */}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/c-linux"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>System Monitoring Tools</h3>
              <p>
                Developed Linux command-line tools in C to visualize /proc
                system info. Added process handling, pipes, signals, and
                real-time outputs for CPU/memory metrics. A compilation of
                assignments for the Systems Programming course at UofT.
              </p>
            </div>
          </a>
        </div>

        {/* Assembly Game */}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/b58-assemblygame"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>Assembly Game</h3>
              <p>
                Created a 2D drawing game in MIPS Assembly with movement,
                scoring, challenges, and drawing-based accuracy detection. Used
                bitmap display for real-time game graphics and logic.
              </p>
            </div>
          </a>
        </div>

        {/* C Shell*/}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/shell-c"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>Unix Shell in C</h3>
              <p>
                Built a Unix shell from scratch in C with command execution,
                pipes, I/O redirection, background processes, and built-in
                commands. Implemented process management using fork, execvp, and
                wait, with direct kernel interfaces.
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Projects;
